import { Injectable } from '@angular/core';
import { ToastController } from "ionic-angular";


@Injectable()
export class ToastProvider {
    constructor(
        public toastCtrl: ToastController) { }

    create(message, style) {
        let toast = this.toastCtrl.create({
            message: message,
            duration: 60000,
            position: 'top',
            cssClass: style,
            showCloseButton: true,
            closeButtonText: 'Ok'
        });
        toast.present()
    }
}



// WEBPACK FOOTER //
// ./src/providers/toast.ts